import { CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined, SettingOutlined } from "@ant-design/icons"
import { Button, Form, InputNumber, Modal, Select, Switch } from "antd"
import { useEffect, useState } from "react"
// import ModalAddTarget from "./ModalAddTarget"
import { checkDisabledPermission, getUserPermissions } from "../../../../until"
import { useSelector } from "react-redux"
import { selectorPermission } from "../../../../store/slices/permissionSlice"
import useToast from "../../../../hook/useToast"
import useLoading from "../../../../hook/useLoading"
import ModalDeleteManager from "../../../../components/ModalDeleteManager"
import { delTarget, getInfoTarget, getListTarget, ITarget } from "../../../../api/target/targetApi"
import useThrottle from "../../../../hook/useThrottle"
// import ModalUpdateTarget from "./ModalUpdateTarget"

interface ModalProps {
    isOpen: boolean
    closeModal: () => void
}
const ModalSetPoint: React.FC<ModalProps> = ({
    isOpen, closeModal
}) => {


    useEffect(() => {
        gSLTarget()

    }, [])


    const pushToast = useToast();
    const pushLoading = useLoading()
    const permissionSlice = useSelector(selectorPermission)
    const { add, edit, delete: isDelete, upload, download, share, } = getUserPermissions(permissionSlice, location.pathname)

    const [isModalAddTarget, setIsModalAddTarget] = useState(false)
    const [isModalUpdateTarget, setIsModalUpdateTarget] = useState(false)
    const [isModalDeleteTarget, setIsModalDeleteTarget] = useState(false)

    const [sLTarget, setSLTarget] = useState<ITarget[]>([])
    const [infoTarget, setInfoTarget] = useState<ITarget>()

    const [id, setId] = useState<number>()


    const gSLTarget = async () => {
        const result = await getListTarget()
        if (result?.status) {
            setSLTarget(result.data)
        } else {
            pushToast(result?.message, "warning")
        }
    }

    const gInfoTarget = useThrottle(async (id: number, isview: boolean = true) => {
        pushLoading(true)
        const result = await getInfoTarget(id)
        if (result?.status) {
            setInfoTarget(result.data)
            openModalUpdate(result.data.id)
        } else {
            pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)

    const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            setIsModalAddTarget(false)
            pushToast(message, "success")
            gSLTarget()
        } else {
            pushToast(message, "error")
        }
    }

    const openModalUpdate = (id: number) => {
        setId(id)
        setIsModalUpdateTarget(true)
    }

    const closeModalUpdate = () => {
        setId(undefined)
        setIsModalUpdateTarget(false)
    }


    const onSubmitFormModalUpdate = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            setIsModalUpdateTarget(false)
            pushToast(message, "success")
            gSLTarget()
        } else {
            pushToast(message, "error")
        }
    }

    const openModalDelete = (id: number) => {
        setId(id)
        setIsModalDeleteTarget(true)
    }

    const closeModalDelete = () => {
        setId(undefined)
        setIsModalDeleteTarget(false)
    }


    const onConfirmDelete = async () => {
        console.log(id)
        if (!id) return
        const result = await delTarget(id)
        if (result?.status) {
            pushToast(result.message, "success")
            closeModalDelete()
            gSLTarget()
        } else {
            pushToast(result?.message, "warning")
        }
    }



    return (
        <Modal
            title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-4 w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                <span className="text-base text-344054 fw-500 font-medium">Cài đặt điểm</span>
                <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
            </div>}
            open={isOpen}
            onCancel={closeModal}
            centered
            className="custom-page-css w-modal modal-content-warning ant-modal-size rounded-2"
            closeIcon={false}
            footer={''}
        >
            {/* <ModalAddTarget
                isOpen={isModalAddTarget}
                onSubmitFormModal={onSubmitFormModalAdd}
                closeModal={() => setIsModalAddTarget(false)}
            />

            <ModalUpdateTarget
                isOpen={isModalUpdateTarget}
                infoTarget={infoTarget}
                onSubmitFormModal={onSubmitFormModalUpdate}
                closeModal={closeModalUpdate}
            /> */}

            <div className="custom-page-css flex flex-col gap-2 rounded-2"
                style={{
                    maxHeight: '70vh',
                    overflowY: 'scroll'
                }}
            >
                <div className="custom-page-css flex flex-col gap-2  py-2 px-4 h-full">
                    <div
                        // key={item.id}
                        className="custom-page-css flex items-start justify-between gap-2"
                    >
                        <div className="custom-page-css flex flex-col ">
                            <span className="custom-page-css text-base">Thời hạn điểm</span>
                            <span className="custom-page-css text-sm text-667085">Điểm sẽ hết hạn sau</span>
                        </div>

                        <div className="custom-page-css flex  justify-end gap-2">
                            <Select
                                className="custom-page-css border rounded overflow-hidden"
                                style={{
                                    width: 120
                                }}
                                options={[
                                    { label: '90 ngày', value: '90 ngày' },
                                    { label: '180 ngày', value: '180 ngày' },
                                    { label: '365 ngày', value: '365 ngày' },
                                    { label: 'Không bao giờ', value: 'Không bao giờ' },

                                ]}
                            />


                        </div>

                    </div>
                    <div
                        // key={item.id}
                        className="custom-page-css flex items-start justify-between gap-2"
                    >
                        <div className="custom-page-css flex flex-col ">
                            <span className="custom-page-css text-base">Quy đổi điểm</span>
                            <span className="custom-page-css text-sm text-667085">1 điiểm = ? đ</span>
                        </div>

                        <div className="custom-page-css flex  justify-end gap-1">
                            <Form.Item
                                name="quantity"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập số lượng voucher phát hành!' },
                                    {
                                        validator: (_, value) => {
                                            // cho phép bỏ trống
                                            if (value === undefined || value === null) {
                                                return Promise.resolve();
                                            }

                                            // nếu có nhập thì phải > 0
                                            if (value <= 0) {
                                                return Promise.reject('Giá trị phải lớn hơn 0');
                                            }

                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <InputNumber<number>
                                    style={{ width: 120 }}
                                    controls={false}
                                    formatter={(value) =>
                                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                                    }
                                    parser={(value) =>
                                        value?.replace(/\./g, '') as unknown as number
                                    }
                                />
                            </Form.Item>

                            <span>đ</span>

                        </div>

                    </div>
                </div>
            </div>
        </Modal>
    )
}
export default ModalSetPoint
